// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3kz9o","approved":"Status_approved__3mTb1","rejected":"Status_rejected__3ngQ2","expired":"Status_expired__2BYBq","label":"Status_label__pX5k7"};